<template>
    <div class="file-dialog">
        <el-dialog :title="fileTypeArr&&fileType&&fileTypeArr[fileType].text" :visible.sync="dialogVisible" @close="beforeClose" center :modal-append-to-body='false'>
            <div class="file-item" v-for="file in files" :key="file">
                <img class="dialog-img" :src="file"/>
                <video v-if="fileType == fileTypeArr.video.value" controls="controls" id="videoFile" class="dialog-video" :src="file"/>
                <audio v-if="fileType == fileTypeArr.voice.value" controls="controls" id="voiceFile" :src="file"  class="dialog-voice"/>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props:['url','fileType','fileList'],
    data(){
        return{
            fileTypeArr:[],
            files:[],
            dialogVisible:false
        }
    },
    watch:{
        url(){
            if(this.url){
                this.files= [this.url];
                this.dialogVisible =true;
            }
        },
        fileList(){
            // console.log(this.fileList)
            if(this.fileList.length>0){
                this.files= this.fileList;
                this.dialogVisible = true;
            }
        }
    },
    created(){
        this.fileTypeArr = this.$utils.fileType;
    },
    methods:{
        beforeClose(){
            if(document.getElementById('videoFile'))
                document.getElementById('videoFile').pause();
            if(document.getElementById('voiceFile'))
                document.getElementById('voiceFile').pause();
            this.$emit('fileDialogClose');
            
        }
    }
}
</script>
<style>
.file-dialog .el-dialog{
    max-height: 80vh;
}
.file-dialog .el-dialog--center .el-dialog__body{
    max-height: calc(80vh - 140px);
    padding-bottom: 20px;
}
.file-dialog .dialog-img{
    margin: 0 auto;
    display: block;
    max-width: 600px;
 }
.file-dialog .dialog-video{
    max-height: calc(80vh - 180px);
    margin: 0 auto;
    display: block;
 }
.file-dialog .dialog-voice{
    width: 400px;
    margin: 0 auto;
    display: block;
 }
 
</style>


// WEBPACK FOOTER //
// src/components/template/fileDialog.vue